import { BaseComponent } from '../../base-component';

export class PromoFlagsComponent extends BaseComponent {
    public rootSelector = '.js_pdp_promo-flags__ambient-button';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) return;
    }
}
